// Miroir exact du backend Python (Story 1.3) — conserver snake_case

export enum RoleLevel {
  LECTEUR = 1,  // groupe Marque_{REGION}_Consultation
  EDITEUR = 2,  // groupe Marque_{REGION}_Responsable
  AP = 3,       // TODO: confirmer groupe AP avec équipe Quadient Interactive
  ADMIN = 4,    // groupe Administrator → OS&A
}

export interface UserContext {
  email: string;
  quadient_id: string;
  permissions: Record<string, RoleLevel>; // ex: { "IDF": RoleLevel.LECTEUR }
  is_admin: boolean;
}
